import React, { useContext, useMemo } from 'react';
import { PatientChartContext } from '../../../contexts/patientChart';
import {
  SEND_TO_PS_REASONS, MODAL_KEY, DROPDOWN, SEND_TO_PS,
  VISIT_URL, RESPONSE_POPUP_KEY, CONFIRMATION_POPUP_KEY,
} from '../../../constants/patientChart.constant';
import { POPUP_TYPE } from '../../subComponents/popup';
import PPButton from '../../subComponents/button';
import Select from '../../subComponents/select';

export const SendToPS = ({
  orderId = 0,
  patientId = 0,
  sendToPSReasons = SEND_TO_PS_REASONS(),
  getScheduledVisits = async (requestBody = {}) => {},
  getAsyncOrders = async (requestBody = {}) => {},
  sendToPS: sendToPSAction = async (requestBody = {}) => {},
  removeOrdersFromLV = (requestBody = { orderIds: [] }) => {},
  handler = { route: () => {} },
}) => {
  const {
    sendToPS,
    setSendToPS,
    loading,
    setLoading,
    visitType,
    handleModalOpen,
    handleMultipleModalClose,
  } = useContext(PatientChartContext);

  const stopLoading = (_loading) => {
    const __loading = new Set(_loading);
    __loading.delete(MODAL_KEY.SEND_TO_PS);
    setLoading(__loading);
  };

  const handleChange = ({ target }) => {
    const reason = sendToPSReasons.valuesCollection.get(target.value) || DROPDOWN();
    setSendToPS({
      value: reason.id,
      summary: {
        ...sendToPS.summary,
        // note: reason.description,
      },
    });
  };

  const handleMessageChange = ({ target }) => {
    setSendToPS({ ...sendToPS, summary: { ...sendToPS.summary, note: target.value } });
  };

  const handleSendToPS = async ({ key }) => {
    const reason = sendToPSReasons.valuesCollection.get(sendToPS.value) || DROPDOWN();
    const requestBody = {
      OrderId: orderId,
      PatientId: patientId,
      SelectedReason: reason.description,
      Note: sendToPS.summary.note,
    };

    const _loading = new Set(loading);
    _loading.add(MODAL_KEY.SEND_TO_PS);
    setLoading(_loading);

    try {
      const { status, data } = await sendToPSAction(requestBody);
      if (status === 200) {
        stopLoading(_loading);
        setSendToPS(SEND_TO_PS());
        removeOrdersFromLV({ orderIds: [orderId] });
        handleMultipleModalClose.call(this, { keys: [key, MODAL_KEY.SEND_TO_PS] });
        getScheduledVisits();
        getAsyncOrders();

        // route only when video call in not on going
        if (!_loading.has(MODAL_KEY.TWILIO)) {
          const visitUrl = VISIT_URL.get(visitType);
          handler.route(visitUrl);
        }
      }

      if (status !== 200) {
        const { Error: error = 'Failed to send the order to patient support. Please try later.' } = data;
        const heading = 'Error';

        handleModalOpen({
          key: RESPONSE_POPUP_KEY.SEND_TO_PS,
          modal: {
            heading,
            type: POPUP_TYPE.ERROR,
            message: error,
          }
        });
      }
    } catch (e) {
      // error handling when needed
    } finally {
      stopLoading(_loading);
    }
  };

  const Template = (
    <div className='flex flex-column flex-fill m-b-5'>
      <div className='flex align-items-center m-b-5'>
        <label className="input-label min-width-55 m-r-4">Reason:</label>
        <Select
          id='templateId'
          labelId="templateId"
          value={sendToPS.value}
          onChange={handleChange}
          items={sendToPSReasons.api.data}
        />
      </div>

      <div className='flex flex-fill align-items-center m-b-5'>
        <label className="input-label min-width-55 m-r-4">Note:</label>
        <textarea
          name='note'
          className='flex flex-fill border-light-grey-1 min-height-160 height-full p-4 font-proxima-nova font-14 color-dark-grey border-box resize-none'
          wrap='soft'
          maxLength={4000}
          value={sendToPS.summary.note}
          onChange={handleMessageChange}
        />
      </div>
    </div>
  );

  const _disabled = useMemo(() => (sendToPS.value === -1 || sendToPS.summary.note.length === 0), [sendToPS]);
  const _loading = useMemo(() => loading.has(MODAL_KEY.SEND_TO_PS), [loading]);

  const Actions = (
    <div className='flex justify-content-flex-end'>
      <PPButton label='Send to Patient Support' variant='contained' loading={_loading} disabled={_disabled} endGutter onClick={handleSendToPS.bind(this, { key: CONFIRMATION_POPUP_KEY.SEND_TO_PS, modal: {} })} />
      <PPButton label='Cancel' variant='cancel' disabled={_loading} onClick={handleMultipleModalClose.bind(this, { keys: [MODAL_KEY.SEND_TO_PS] })} />
    </div>
  );

  return (
    <div className='flex flex-column flex-fill m-5 patient-chart-container'>
      {Template}
      {Actions}
    </div>
  );
};

export default SendToPS;
